<section id="waitlist_main_container"
  class="h-screen slide px-4 md:px-14 lg:px-[108px] flex items-center relative bg-purple_100">
  <div class="flex flex-col gap-10" [@fadeInLeftOnEnter]>
    <div class="flex flex-col gap-4 text-white">
      <h1 class="text-hurrey-28 lg:text-hurrey-48 md:w-[75%] font-bold" style="font-weight: 700 !important;">Your
        Classroom’s Smartest Upgrade is Here.India’s First
        AI-Powered Education OS</h1>
      <p class="text-white text-hurrey-16 break-words md:w-[70%]">From individualized learning insights to smart school
        management, Atomo transforms any classroom into an intelligent ecosystem.</p>
      <p class="text-white text-hurrey-16 break-words md:w-[70%]">No extra staff. No complicated tech. Just one
        SuperApp.</p>
      <a role="button" href="https://forms.gle/35Gj1bT9MC9hckcw8" target="_blank" class="explore_button mt-2"
        id="join_waitlist">Join The Waitlist</a>
    </div>
  </div>
</section>

<section id="why-partner-with-us" class="px-4 md:px-14 lg:px-[108px] py-4 md:py-14">
  <who-is-it-for></who-is-it-for>
</section>

<section id="reseller-advantages" class="px-4 md:px-14 lg:px-[108px] py-4 md:py-5">
  <why-atomo></why-atomo>
</section>



<!-- <section id="become-a-reseller" class="px-4 md:px-14 lg:px-[108px] py-4 md:py-10 bg-purple_40">

</section> -->


<section id="atomo_ai_container" class="atomo_ai_container bg-purple_40">

  <div class="flex flex-col items-start justify-start px-4 md:px-14 lg:px-28 py-4 md:py-10 gap-8">
    <div class="flex flex-col gap-4 md:gap-8">
    <h3 class="text-hurrey-24 md:text-hurrey-28 lg:text-hurrey-36 ">Be the First to Experience the Future of Learning
    </h3>
    <div class="flex flex-col lg:flex-row items-center justify-between gap-8">
      <!-- Step 1 -->
      <div class="text-center flex flex-col items-center gap-3">
        <div
          class="h-12 w-12 md:h-16 md:w-16 flex items-center justify-center bg-purple_100 text-white text-hurrey-20 rounded-half">
          1
        </div>
        <h3 class="text-hurrey-16 md:text-hurrey-20 lg:text-hurrey-24 font-semibold"> Priority access when we launch
        </h3>
      </div>

      <!-- Connector -->
      <div class="hidden lg:block h-1 w-16 bg-sky_dark"></div>

      <!-- Step 2 -->
      <div class="text-center flex flex-col items-center gap-3">
        <div
          class="h-12 w-12 md:h-16 md:w-16 flex items-center justify-center bg-purple_100 text-white text-hurrey-20 rounded-half">
          2
        </div>
        <h3 class="text-hurrey-16 md:text-hurrey-20 lg:text-hurrey-24 font-semibold"> Individualized onboarding</h3>
      </div>

      <!-- Connector -->
      <div class="hidden lg:block h-1 w-16 bg-sky_dark"></div>

      <!-- Step 3 -->
      <div class="text-center flex flex-col items-center gap-3">
        <div
          class="h-12 w-12 md:h-16 md:w-16 flex items-center justify-center bg-purple_100 text-white text-hurrey-20 rounded-half">
          3
        </div>
        <h3 class="text-hurrey-16 md:text-hurrey-20 lg:text-hurrey-24 font-semibold"> Free for early adopters</h3>
      </div>
    </div>

  </div>
    <div class="text-style">
      <p class=" text-hurrey-36 lg:text-hurrey-48 " id="atomo-offerings">
        Teachers are overwhelmed. Students are falling through the cracks. Atomo is here to fix that, one smart classroom
        at a time.
      </p>
    </div>
    <a role="button" href="https://forms.gle/35Gj1bT9MC9hckcw8" target="_blank" class="waitlist" id="join_waitlist">Join
      The Waitlist</a>

  </div>
</section>
